import { render, staticRenderFns } from "./QuestionOauth.vue?vue&type=template&id=54896e17&scoped=true&"
import script from "./QuestionOauth.vue?vue&type=script&lang=js&"
export * from "./QuestionOauth.vue?vue&type=script&lang=js&"
import style0 from "./QuestionOauth.vue?vue&type=style&index=0&id=54896e17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54896e17",
  null
  
)

export default component.exports